module.exports = __webpack_public_path__ + "img/more_square.1c5f8f1a.svg";